import { render, staticRenderFns } from "./EvaluationPage.vue?vue&type=template&id=70dd5953"
import script from "./EvaluationPage.vue?vue&type=script&lang=js"
export * from "./EvaluationPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports